<div
  class="hidden sm:flex relative flex-col justify-center items-center px-1 py-2 w-full bg-opacity-60 max-md:px-5 max-md:max-w-full"
>
  <main
    class="overflow-hidden w-full max-w-[866px] bg-white rounded-2xl"
    [attr.space]="0"
    *ngIf="!createForm && !verificationStep && !verificationOnly"
  >
    <div class="flex max-md:flex-col">
      <div class="w-6/12 max-md:ml-0 max-md:w-full">
        <section
          class="flex overflow-hidden grow gap-2 py-4 pl-4 w-full bg-white min-h-[526px] text-blue-950"
        >
          <div
            class="overflow-hidden flex-1 shrink px-4 pt-8 pb-44 w-full bg-sky-50 rounded-lg basis-0 min-w-60 max-md:pr-5 max-md:pb-24"
          >
            <div class="w-full">
              <header class="w-full">
                <h1 class="text-2xl font-bold leading-none">
                  Welcome To ReWiRe
                </h1>
                <p class="mt-3 text-sm font-medium leading-5 opacity-60">
                  Login or Sign up to explore a vast selection of quality
                  second-hand parts and scrap materials-affordable, sustainable,
                  and all in one place
                </p>
              </header>
              <!-- <section
                class="flex flex-wrap gap-5 items-start mt-6 w-full text-xs font-bold leading-none text-right"
              >
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/736f26a7d8016db59af457f6c522e11d3f6596c0?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  alt="Brand logo"
                  class="object-contain shrink-0 w-14 aspect-square"
                />
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/5b03cc47068d2ab5458cda7dd5647b39bf37e226?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  alt="Brand logo"
                  class="object-contain shrink-0 w-14 aspect-square"
                />
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/c8f1013810691174bd07e26325683dd2e73d8f0e?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  alt="Brand logo"
                  class="object-contain shrink-0 w-14 aspect-square"
                />
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/d88681cec30ba0e955bf0fad4eaaff09fd6b867a?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  alt="Brand logo"
                  class="object-contain shrink-0 w-14 aspect-square"
                />
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/b376c24f024026efe08dcd2d3bec22d890358278?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  alt="Brand logo"
                  class="object-contain shrink-0 w-14 aspect-square"
                />
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/4299fba2f893da2bbdddcf9b85a87c086319109d?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  alt="Brand logo"
                  class="object-contain shrink-0 w-14 aspect-square"
                />
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/8eb4007dcda549b823d694889c56099406858173?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  alt="Brand logo"
                  class="object-contain shrink-0 w-14 aspect-square"
                />
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/4d88df50fe8d2c0d238ad78be78906ec814b46c7?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  alt="Brand logo"
                  class="object-contain shrink-0 w-14 aspect-square"
                />
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/6ace1c85897dfe1b8e94248a773e221550d65789?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  alt="Brand logo"
                  class="object-contain shrink-0 w-14 aspect-square"
                />
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/c26577693c5ceee3fa44d6095662f0e5a42b0178?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  alt="Brand logo"
                  class="object-contain shrink-0 w-14 aspect-square"
                />
                <p class="grow shrink w-[346px]">And many more</p>
              </section> -->
            </div>
          </div>
        </section>
      </div>
      <div class="ml-1 w-6/12 max-md:ml-0 max-md:w-full" *ngIf="showLoginModal">
        <div class="flex flex-col grow mt-2 max-md:max-w-full">
          <button
            (click)="closeModal()"
            class="self-end mr-5 p-2 hover:bg-gray-100 rounded-full transition-colors duration-200 max-md:mr-2.5"
            aria-label="Close modal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <section class="flex flex-col justify-center mx-6 max-md:mx-2.5">
            <h2
              class="flex-1 shrink gap-2 self-stretch w-full text-2xl font-bold leading-none text-black basis-0"
            >
              Login or Signup
            </h2>
            <form
              [formGroup]="loginForm"
              class="mt-5 w-full"
              (ngSubmit)="getOtp()"
            >
              <div class="flex flex-col gap-2 items-start w-full">
                <label class="text-sm font-bold text-zinc-700">
                  Mobile Number
                </label>

                <input
                  #mobileNumberInput
                  id="mobileNumber"
                  type="tel"
                  formControlName="phoneNumber"
                  maxlength="10"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  (keypress)="onlyNumbers($event)"
                  class="p-2 w-full text-base font-medium text-black rounded-lg border border-solid"
                  [ngClass]="{
                    'border-neutral-300': !shouldShowPhoneError(),
                    'border-red-500': shouldShowPhoneError(),
                  }"
                  placeholder="Enter your mobile number"
                  aria-label="Mobile Number"
                  autofocus
                />
                <div
                  *ngIf="shouldShowPhoneError()"
                  class="text-red-500 text-sm mt-1"
                >
                  <span
                    *ngIf="loginForm.get('phoneNumber')?.errors?.['required']"
                    >Mobile number is required</span
                  >
                  <span
                    *ngIf="loginForm.get('phoneNumber')?.errors?.['pattern']"
                    >Please enter a valid 10-digit mobile number</span
                  >
                </div>
                <!-- <div *ngIf="errorMessage" class="text-red-500 text-sm mt-2 text-center">
                  {{ errorMessage }}
                </div> -->
              </div>
              <div id="turnstile-container" class="mb-3 mt-3"></div>
              <div class="flex items-center gap-2 mt-4">
                <label
                  for="termsAccepted"
                  class="text-sm font-medium text-black"
                >
                  By continuing, I agree to
                  <a
                    href="/terms-condition"
                    class="text-blue-500 hover:underline"
                    >Terms & conditions</a
                  >
                  and
                  <a
                    href="/privacy-policy"
                    class="text-blue-500 hover:underline"
                    >Privacy Policies</a
                  >
                </label>
              </div>
            </form>
          </section>
          <footer
            class="flex flex-col justify-center items-end ml-3 px-12 w-full text-base font-bold text-center text-white bg-white max-md:px-5 max-md:max-w-full"
            [ngClass]="{
              'mt-[168px] max-md:mt-10':
                !shouldShowPhoneError() && !errorMessage,
              'mt-[132px] max-md:mt-8': shouldShowPhoneError() || errorMessage,
            }"
          >
            <button
              type="submit"
              [disabled]="
                loginForm.get('phoneNumber')?.value?.length !== 10 ||
                !turnstileToken ||
                loading
              "
              (click)="getOtp()"
              class="p-2 w-20 text-base font-bold text-white rounded-lg bg-blue-950 max-md:w-full max-sm:px-1 max-sm:py-2 w-[150px]"
              [ngClass]="{
                'opacity-50 cursor-not-allowed':
                  loginForm.get('phoneNumber')?.value?.length !== 10 ||
                  !turnstileToken ||
                  loading,
                'hover:bg-blue-900':
                  loginForm.get('phoneNumber')?.value?.length === 10 &&
                  turnstileToken &&
                  !loading,
              }"
            >
              <span class="gap-2 self-stretch my-auto">
                <ng-container>Get OTP</ng-container>
              </span>
            </button>
          </footer>
        </div>
      </div>

      <div class="w-6/12 max-md:ml-0 max-md:w-full" *ngIf="verifyOtp">
        <div class="flex flex-col grow mt-2 max-md:max-w-full">
          <button
            (click)="closeModal()"
            class="self-end mr-5 p-2 hover:bg-gray-100 rounded-full transition-colors duration-200 max-md:mr-2.5"
            aria-label="Close modal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <section class="flex flex-col justify-center mx-6 max-md:mx-2.5">
            <h2
              class="flex-1 shrink gap-2 self-stretch w-full text-2xl font-bold leading-none text-black basis-0"
            >
              Enter OTP
            </h2>
            <div class="mt-5 w-full">
              <div
                class="flex gap-1 items-center w-full text-sm font-medium leading-none"
              >
                <p class="self-stretch my-auto">
                  <span style="color: rgba(119, 119, 119, 1)"
                    >OTP has been sent to</span
                  >
                  <span style="color: rgba(0, 0, 0, 1)">
                    {{ phoneNumber }}</span
                  >
                </p>
                <button
                  class="self-stretch my-auto text-blue-500"
                  (click)="onEditClick()"
                  aria-label="Edit phone number"
                >
                  Edit
                </button>
              </div>
              <form [formGroup]="otpForm" class="flex gap-2 mt-5">
                <ng-container
                  *ngFor="let controlName of otpControls; let i = index"
                >
                  <input
                    type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    maxlength="1"
                    class="w-12 h-12 text-center border rounded focus:outline-none"
                    [ngClass]="{
                      'border-gray-400 focus:border-blue-500':
                        !otpForm.get(controlName)?.touched ||
                        otpForm.get(controlName)?.valid,
                      'border-2 border-red-500':
                        (otpForm.get(controlName)?.touched &&
                          otpForm.get(controlName)?.invalid) ||
                        errorMessage,
                    }"
                    [formControlName]="controlName"
                    (input)="onInput($event, i)"
                    (keydown)="onKeyDown($event, i)"
                    #otpInput
                    autocomplete="off"
                    [attr.data-index]="i"
                    placeholder="-"
                  />
                  <!-- Auto-focus to next input is handled in onInput() in TS -->
                </ng-container>
              </form>

              <p
                class="gap-2 self-stretch mt-2 w-full text-sm font-medium leading-none"
                [ngClass]="{
                  'text-neutral-500': remainingSeconds > 0,
                  'text-blue-500 cursor-pointer': remainingSeconds === 0,
                }"
                (click)="resendOtp()"
              >
                <span
                  *ngIf="errorMessage"
                  class="text-red-500 gap-2 self-stretch mt-2 w-full text-sm font-bold leading-none"
                >
                  {{ errorMessage }}
                </span>
                {{ resendText }}
              </p>
            </div>
          </section>
          <footer
            class="flex flex-col justify-center items-end px-6 py-4 w-full text-base font-bold text-center text-white bg-white max-md:px-5 max-md:max-w-full mt-[255px]"
            [ngClass]="{
              'max-md:mt-10': !errorMessage,
              'max-md:mt-8': errorMessage,
            }"
          >
            <button
              type="submit"
              [disabled]="!otpForm.valid || loading"
              class="flex gap-1 justify-center items-center p-2 max-w-full rounded-lg bg-blue-950 w-[150px]"
              [ngClass]="{
                'opacity-50 cursor-not-allowed': !otpForm.valid || loading,
              }"
              (click)="verifyOtpSubmit()"
              (keyup.enter)="verifyOtpSubmit()"
            >
              <span class="gap-2 self-stretch my-auto">
                <ng-container>Verify</ng-container>
              </span>
            </button>
          </footer>
        </div>
      </div>
    </div>
  </main>

  <main
    class="overflow-hidden w-full max-w-[866px] bg-white rounded-2xl"
    [attr.space]="0"
    *ngIf="createForm"
  >
    <app-register
      [businessOnly]="registerBusinessOnly"
      [checkoutMode]="verificationCheckoutMode"
      (businessStepComplete)="onBusinessStepComplete($event)"
      (closeModal)="onRegisterClose()"
    ></app-register>
  </main>

  <!-- GSTIN / Status / Activated steps (managed in login) -->
  <main
    class="overflow-hidden w-full max-w-[866px] bg-white rounded-2xl"
    [attr.space]="0"
    *ngIf="verificationStep"
  >
    <div class="flex flex-col md:flex-row w-full min-h-0">
      <div class="md:hidden px-4 py-4 sm:px-6 sm:py-5 bg-sky-50 text-blue-950 sm:mx-4 sm:mt-3 sm:rounded-lg">
        <h2 class="text-xl sm:text-2xl font-bold leading-tight">{{ verificationLeftPanelTitle }}</h2>
        <p class="mt-2 text-sm font-medium leading-5 opacity-60">{{ verificationLeftPanelSubtext }}</p>
      </div>

      <div class="hidden md:flex md:w-1/2 h-auto mx-4 my-3 pr-2 bg-sky-50 rounded-lg shrink-0">
        <section class="overflow-hidden px-4 pt-8 pb-4 bg-sky-50 rounded-lg w-full max-w-[405px] text-blue-950">
          <header class="w-full">
            <h2 class="text-2xl font-bold leading-none">{{ verificationLeftPanelTitle }}</h2>
            <p class="mt-3 text-sm font-medium leading-5 opacity-60">{{ verificationLeftPanelSubtext }}</p>
          </header>
        </section>
      </div>

      <div class="w-full md:w-1/2 flex-1 min-w-0 px-4 sm:px-6 py-4 md:py-5 lg:py-3">
        <section class="flex relative flex-col w-full max-w-[480px] lg:max-w-[445px] mx-auto lg:mx-0">
          <ng-container *ngIf="verificationStep === 'gstin'">
            <button (click)="closeModal()" class="hidden md:block self-end mr-2 p-2 hover:bg-gray-100 rounded-full" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <div class="flex flex-col gap-4 sm:gap-5 items-start w-full">
              <h1 class="text-xl sm:text-2xl font-bold leading-8 text-black">Select GSTIN</h1>
              <p class="text-sm sm:text-base font-medium leading-5 text-black opacity-60">
                Choose an active GSTIN to verify your business instantly.
              </p>
              <div class="flex flex-col gap-2 w-full max-h-[45vh] sm:max-h-[320px] overflow-y-auto pr-1">
                <div *ngFor="let g of gstins"
                  class="relative flex justify-between items-center p-3 rounded-lg border border-solid transition-colors min-h-[56px]"
                  [class.border-blue-500]="isGstinSelected(g)" [class.bg-blue-50]="isGstinSelected(g)"
                  [class.border-neutral-300]="!isGstinSelected(g)" [class.opacity-50]="!isGstinActive(g)"
                  [class.cursor-pointer]="isGstinActive(g)"
                  [style.pointer-events]="isGstinActive(g) ? 'auto' : 'none'"
                  (click)="onGstinSelect(g)">
                  <div class="flex flex-col pr-16 min-w-0">
                    <span class="font-bold text-sm text-black break-all">{{ g.document_number || g.gstin }}</span>
                    <span class="text-xs text-neutral-500">{{ g.state }}</span>
                  </div>
                  <span *ngIf="!isGstinActive(g)" class="absolute top-2 right-2 text-[10px] sm:text-xs font-medium text-red-500 uppercase">
                    {{ g.status || g.gstin_status }}
                  </span>
                </div>
              </div>
              <div class="flex justify-end mt-6 sm:mt-10 lg:mt-12 w-full">
                <button type="button" (click)="onGstinSubmit()"
                  class="p-2.5 sm:p-2 text-base font-bold text-white rounded-lg bg-blue-950 w-full sm:w-[200px]"
                  [class.opacity-60]="!selectedGstin || gstinLoading" [disabled]="!selectedGstin || gstinLoading">
                  <ng-container *ngIf="!gstinLoading">Continue</ng-container>
                  <ng-container *ngIf="gstinLoading">Verifying...</ng-container>
                </button>
              </div>
              <div *ngIf="gstinErrorMessage" class="text-red-500 text-sm mt-2 text-center w-full">{{ gstinErrorMessage }}</div>
            </div>
          </ng-container>

          <ng-container *ngIf="verificationStep === 'shop-license'">
            <button (click)="closeModal()" class="hidden md:block self-end mr-2 p-2 hover:bg-gray-100 rounded-full" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <div class="flex flex-col gap-4 sm:gap-5 items-start w-full">
              <h1 class="text-xl sm:text-2xl font-bold leading-8 text-black">Shop License Details</h1>
              <p class="text-sm sm:text-base font-medium leading-5 text-black opacity-60">
                No GSTINs were found for your PAN. Enter your shop license details to verify your business.
              </p>
              <div class="flex flex-col gap-4 items-start w-full">
                <div class="flex flex-col gap-1 w-full">
                  <label class="text-xs sm:text-sm font-bold text-zinc-700">Verification Type</label>
                  <select
                    [(ngModel)]="shopLicenseType"
                    (ngModelChange)="onShopLicenseTypeChange()"
                    class="p-2 w-full h-10 text-base font-medium text-black rounded-lg border border-neutral-300 transition-all duration-200 bg-white"
                  >
                    <option *ngFor="let option of shopLicenseTypeOptions" [ngValue]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>

                <ng-container *ngIf="shopLicenseType === 'uam'">
                  <div class="flex flex-col gap-1 w-full">
                    <label class="text-xs sm:text-sm font-bold text-zinc-700">UAM Number</label>
                    <select
                      *ngIf="udyamItems.length; else desktopUamManualInput"
                      [(ngModel)]="uamNumber"
                      (blur)="uamNumberTouched = true"
                      class="p-2 w-full h-10 text-base font-medium text-black rounded-lg border transition-all duration-200 bg-white"
                      [class.border-red-500]="getUamNumberError()"
                      [class.border-neutral-300]="!getUamNumberError()"
                    >
                      <option value="" disabled>Select UAM number</option>
                      <option *ngFor="let u of udyamItems" [ngValue]="getUdyamNumber(u)">
                        {{ getUdyamNumber(u) }}
                      </option>
                    </select>
                    <ng-template #desktopUamManualInput>
                      <input
                        type="text"
                        [(ngModel)]="uamNumber"
                        (blur)="uamNumberTouched = true"
                        (keyup.enter)="onShopLicenseSubmit()"
                        placeholder="Enter UAM number"
                        class="p-2 w-full h-10 text-base font-medium text-black rounded-lg border transition-all duration-200"
                        [class.border-red-500]="getUamNumberError()"
                        [class.border-neutral-300]="!getUamNumberError()"
                      />
                    </ng-template>
                    <div
                      *ngIf="selectedUdyamItem?.state || selectedUdyamItem?.address"
                      class="flex flex-col gap-1 p-3 mt-2 text-sm text-zinc-700 rounded-lg border border-neutral-300 bg-zinc-100"
                    >
                      <span *ngIf="selectedUdyamItem?.state">State: {{ selectedUdyamItem?.state }}</span>
                      <span *ngIf="selectedUdyamItem?.address">
                        Address: {{ selectedUdyamItem?.address }}<ng-container *ngIf="selectedUdyamItem?.pincode"> - {{ selectedUdyamItem?.pincode }}</ng-container>
                      </span>
                    </div>
                    <div *ngIf="uamLookupLoading" class="text-xs mt-1 text-neutral-500">
                      Fetching UAM numbers...
                    </div>
                    <div *ngIf="uamLookupErrorMessage" class="text-red-500 text-xs mt-1">
                      {{ uamLookupErrorMessage }}
                    </div>
                    <div *ngIf="getUamNumberError()" class="text-red-500 text-xs mt-1">
                      {{ getUamNumberError() }}
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="shopLicenseType === 'certificate'">
                  <div class="flex flex-col gap-1 w-full">
                    <label class="text-xs sm:text-sm font-bold text-zinc-700">Certificate Number</label>
                    <input
                      type="text"
                      [(ngModel)]="shopLicenseNumber"
                      (blur)="shopLicenseNumberTouched = true"
                      (keyup.enter)="onShopLicenseSubmit()"
                      placeholder="Enter shop license certificate number"
                      class="p-2 w-full h-10 text-base font-medium text-black rounded-lg border transition-all duration-200"
                      [class.border-red-500]="getShopLicenseNumberError()"
                      [class.border-neutral-300]="!getShopLicenseNumberError()"
                    />
                    <div *ngIf="getShopLicenseNumberError()" class="text-red-500 text-xs mt-1">
                      {{ getShopLicenseNumberError() }}
                    </div>
                  </div>
                  <div class="flex flex-col gap-1 w-full">
                    <label class="text-xs sm:text-sm font-bold text-zinc-700">State</label>
                    <select
                      [(ngModel)]="shopLicenseState"
                      (blur)="shopLicenseStateTouched = true"
                      class="p-2 w-full h-10 text-base font-medium text-black rounded-lg border transition-all duration-200 bg-white"
                      [class.border-red-500]="getShopLicenseStateError()"
                      [class.border-neutral-300]="!getShopLicenseStateError()"
                    >
                      <option value="" disabled>Select state</option>
                      <option *ngFor="let state of shopLicenseStates" [value]="state">
                        {{ formatShopLicenseStateLabel(state) }}
                      </option>
                    </select>
                    <div *ngIf="getShopLicenseStateError()" class="text-red-500 text-xs mt-1">
                      {{ getShopLicenseStateError() }}
                    </div>
                  </div>
                  <div class="flex flex-col gap-1 w-full">
                    <label class="text-xs sm:text-sm font-bold text-zinc-700">Commencement Date</label>
                    <input
                      type="date"
                      [(ngModel)]="shopLicenseCommencementDate"
                      (blur)="shopLicenseCommencementDateTouched = true"
                      (keyup.enter)="onShopLicenseSubmit()"
                      class="p-2 w-full h-10 text-base font-medium text-black rounded-lg border transition-all duration-200"
                      [class.border-red-500]="getShopLicenseCommencementDateError()"
                      [class.border-neutral-300]="!getShopLicenseCommencementDateError()"
                    />
                    <div *ngIf="getShopLicenseCommencementDateError()" class="text-red-500 text-xs mt-1">
                      {{ getShopLicenseCommencementDateError() }}
                    </div>
                  </div>
                  <div class="flex flex-col gap-1 w-full">
                    <label class="text-xs sm:text-sm font-bold text-zinc-700">District</label>
                    <input
                      type="text"
                      [(ngModel)]="shopLicenseDistrict"
                      (blur)="shopLicenseDistrictTouched = true"
                      (keyup.enter)="onShopLicenseSubmit()"
                      placeholder="Enter district"
                      class="p-2 w-full h-10 text-base font-medium text-black rounded-lg border transition-all duration-200"
                      [class.border-red-500]="getShopLicenseDistrictError()"
                      [class.border-neutral-300]="!getShopLicenseDistrictError()"
                    />
                    <div *ngIf="getShopLicenseDistrictError()" class="text-red-500 text-xs mt-1">
                      {{ getShopLicenseDistrictError() }}
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="flex justify-end mt-6 sm:mt-10 lg:mt-12 w-full">
                <button type="button" (click)="onShopLicenseSubmit()"
                  class="p-2.5 sm:p-2 text-base font-bold text-white rounded-lg bg-blue-950 w-full sm:w-[200px]"
                  [class.opacity-60]="!isShopLicenseValid() || shopLicenseLoading"
                  [disabled]="!isShopLicenseValid() || shopLicenseLoading">
                  <ng-container *ngIf="!shopLicenseLoading">Continue</ng-container>
                  <ng-container *ngIf="shopLicenseLoading">Verifying...</ng-container>
                </button>
              </div>
              <div *ngIf="shopLicenseErrorMessage" class="text-red-500 text-sm mt-2 text-center w-full">
                {{ shopLicenseErrorMessage }}
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="verificationStep === 'status'">
            <div class="flex flex-col gap-4 sm:gap-5 items-center text-center w-full py-4 sm:py-6">
              <div *ngIf="verificationStatusState === 'verified'" class="w-12 h-12 rounded-full bg-green-50 text-green-600 flex items-center justify-center">
                <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
              </div>
              <div *ngIf="verificationStatusState === 'failed'" class="w-12 h-12 rounded-full bg-red-50 text-red-600 flex items-center justify-center">
                <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
              </div>
              <h1 class="text-xl sm:text-2xl font-bold leading-8 text-black">{{ verificationLeftPanelTitle }}</h1>
              <p class="text-sm sm:text-base font-medium leading-5 text-black opacity-60 px-2">{{ verificationStatusDetail }}</p>
              <div class="flex justify-center mt-6 sm:mt-10 lg:mt-12 w-full">
                <button *ngIf="verificationStatusState === 'verified'" type="button" (click)="onVerificationStatusContinue()"
                  class="p-2.5 sm:p-2 text-base font-bold text-white rounded-lg bg-blue-950 w-full sm:w-[200px]">Continue</button>
                <button *ngIf="verificationStatusState === 'failed'" type="button" (click)="onVerificationStatusRetry()"
                  class="p-2.5 sm:p-2 text-base font-bold text-white rounded-lg bg-blue-950 w-full sm:w-[200px]">Retry</button>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="verificationStep === 'activated'">
            <div class="flex flex-col gap-4 sm:gap-5 items-center text-center w-full py-6 sm:py-8">
              <div class="w-12 h-12 rounded-full bg-green-50 text-green-600 flex items-center justify-center">
                <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
              </div>
              <h1 class="text-xl sm:text-2xl font-bold leading-8 text-black">Account activated</h1>
              <p class="text-sm sm:text-base font-medium leading-5 text-black opacity-60 px-2">
                Your business is verified. Start exploring parts and scrap on ReWiRe.
              </p>
              <div class="flex justify-center mt-6 sm:mt-10 lg:mt-12 w-full">
                <button type="button" (click)="onAccountActivated()"
                  class="p-2.5 sm:p-2 text-base font-bold text-white rounded-lg bg-blue-950 w-full sm:w-[200px]">Start browsing</button>
              </div>
            </div>
          </ng-container>
        </section>
      </div>
    </div>
  </main>
</div>
<!-- </section> -->

<!-- mobile view section -->
<main
  *ngIf="!createForm && !verificationStep && !verificationOnly"
  class="relative mx-auto max-w-none bg-white h-screen w-full sm:hidden flex flex-col"
>
  <!-- Mobile Header -->
  <header
    class="flex items-center justify-between px-4 py-3 bg-blue-200 min-h-[52px] flex-shrink-0"
  >
    <!-- Logo -->
    <img
      src="https://cdn.builder.io/api/v1/image/assets/TEMP/1b50e285eed6bc024f06731dea605f2b1649af32?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
      alt="Company Logo"
      class="w-[133px] object-contain"
    />

    <!-- Divider -->
    <div class="w-px h-6 bg-neutral-300"></div>

    <!-- Circularity -->
    <div
      class="flex items-center gap-1 text-xs font-semibold tracking-wide text-blue-950"
    >
      <div class="relative w-6 h-6">
        <svg
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="w-full h-full"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M3.5 9.5C4.87 4.39 10.14 1.35 15.26 2.73C18.69 3.65 21.19 6.31 22.05 9.52M3.5 9.5L1.8 6.57M3.5 9.5L6.86 8.55M22.05 14.48C20.67 19.61 15.41 22.64 10.29 21.27C6.86 20.35 4.36 17.69 3.5 14.48M22.05 14.48L23.74 17.42M22.05 14.48L18.68 15.45"
              stroke="#0A0A5F"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <text
            x="6"
            y="18"
            fill="#0A0A5F"
            font-size="18"
            font-family="Arial, sans-serif"
          >
            C
          </text>
          <defs>
            <clipPath id="clip0">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <span class="text-sm tracking-widest">IRCULARITY</span>
    </div>

    <!-- Divider -->
    <div class="w-px h-6 bg-neutral-300"></div>

    <!-- Menu Icon -->
    <img
      src="https://cdn.builder.io/api/v1/image/assets/TEMP/d74ff25c4e6b16aca0d967432703b6b2a47b1f47?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
      alt="Menu"
      class="w-8 object-contain"
    />
  </header>

  <section
    class="flex justify-center items-center pt-[14px] pr-[12px] pb-[20px] pl-[12px] bg-sky-50 max-md:w-full max-sm:px-2 max-sm:py-3"
  >
    <div class="flex flex-col gap-5 items-start">
      <h1 class="text-xl font-bold text-blue-950">Welcome To ReWiRe</h1>
      <p class="text-sm font-medium opacity-60 text-blue-950">
        Login or Sign up to explore a vast selection of quality second-hand
        parts and scrap materials.
      </p>
    </div>
  </section>
  <section
    *ngIf="!verifyOtp"
    class="flex flex-col items-start pt-[14px] pr-[12px] pb-[12px] pl-[12px] bg-white rounded-t-[24px] max-md:w-full max-sm:px-2 max-sm:py-3 flex-1"
  >
    <h2 class="text-xl font-bold text-black">Login or Sign up</h2>

    <form [formGroup]="loginForm" class="w-full" (ngSubmit)="getOtp()">
      <div class="flex flex-col gap-2 items-start w-full mt-5">
        <label class="text-sm font-bold text-zinc-700">Mobile Number</label>
        <input
          #mobileNumberInputMobile
          id="mobileNumberMobile"
          type="tel"
          formControlName="phoneNumber"
          maxlength="10"
          pattern="[0-9]*"
          inputmode="numeric"
          (keypress)="onlyNumbers($event)"
          class="p-2 w-full text-base font-medium text-black rounded-lg border border-solid"
          [ngClass]="{
            'border-neutral-300': !shouldShowPhoneError(),
            'border-red-500': shouldShowPhoneError(),
          }"
          placeholder="Enter your mobile number"
          aria-label="Mobile Number"
          autofocus
        />
        <div *ngIf="shouldShowPhoneError()" class="text-red-500 text-sm mt-1">
          <span *ngIf="loginForm.get('phoneNumber')?.errors?.['required']"
            >Mobile number is required</span
          >
          <span *ngIf="loginForm.get('phoneNumber')?.errors?.['pattern']"
            >Please enter a valid 10-digit mobile number</span
          >
        </div>
        <div *ngIf="errorMessage" class="text-red-500 text-sm mt-2 text-center">
          {{ errorMessage }}
        </div>
      </div>

      <div id="turnstile-container-mobile" class="mb-3 mt-3"></div>

      <div class="flex items-center gap-2 mt-4">
        <label for="termsAccepted" class="text-sm font-medium text-black">
          By continuing, I agree to
          <a href="/terms-condition" class="text-blue-500 hover:underline"
            >Terms & conditions</a
          >
          and
          <a href="/privacy-policy" class="text-blue-500 hover:underline"
            >Privacy Policies</a
          >
        </label>
      </div>

      <div *ngIf="!verifyOtp" class="mt-6 bg-white">
        <button
          type="submit"
          [disabled]="
            loginForm.get('phoneNumber')?.value?.length !== 10 ||
            !turnstileToken ||
            loading
          "
          class="p-2 w-full text-base font-bold text-white rounded-lg bg-blue-950 max-md:w-full max-sm:px-1 max-sm:py-2"
          [ngClass]="{
            'opacity-50 cursor-not-allowed':
              loginForm.get('phoneNumber')?.value?.length !== 10 ||
              !turnstileToken ||
              loading,
            'hover:bg-blue-900':
              loginForm.get('phoneNumber')?.value?.length === 10 &&
              turnstileToken &&
              !loading,
          }"
        >
          <span class="gap-2 self-stretch my-auto">
            <ng-container>Get OTP</ng-container>
          </span>
        </button>
      </div>
    </form>
  </section>

  <div class="w-full h-full flex flex-col" *ngIf="verifyOtp">
    <!-- Mobile Header for OTP -->
    <div class="flex flex-col grow">
      <section class="flex flex-col justify-center mx-6 max-md:mx-2.5">
        <h2
          class="flex items-center gap-2 self-stretch w-full text-2xl font-bold leading-none text-black basis-0 mt-4"
        >
          <svg
            (click)="onEditClick()"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="width: 24px; height: 24px"
          >
            <path
              d="M15 6L9 12L15 18"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          OTP Verification
        </h2>
        <div class="mt-5 w-full">
          <div
            class="flex gap-1 items-center w-full text-sm font-medium leading-none"
          >
            <p class="self-stretch my-auto">
              <span style="color: rgba(119, 119, 119, 1)"
                >Enter OTP received on</span
              >
              <span style="color: rgba(0, 0, 0, 1)"> {{ phoneNumber }}</span>
            </p>
            <button
              class="self-stretch my-auto text-blue-500"
              (click)="onEditClick()"
              aria-label="Edit phone number"
            >
              Edit
            </button>
          </div>
          <!-- ng-otp-input for mobile view -->
          <div class="mt-5" [ngClass]="{ 'otp-error': hasOtpError }">
            <ng-otp-input
              [config]="getOtpConfig()"
              (onInputChange)="onOtpChange($event)"
            ></ng-otp-input>
          </div>
          <div
            *ngIf="errorMessage"
            class="text-red-500 gap-2 self-stretch mt-2 w-full text-sm font-medium leading-none"
          >
            {{ errorMessage }}
          </div>
          <p
            class="gap-2 self-stretch mt-2 w-full text-sm font-medium leading-none"
            [ngClass]="{
              'text-neutral-500': remainingSeconds > 0,
              'text-blue-500 cursor-pointer': remainingSeconds === 0,
            }"
            (click)="resendOtp()"
          >
            {{ resendText }}
          </p>
        </div>

        <div
          class="flex flex-col justify-center items-end w-full text-base font-bold text-center text-white bg-white max-md:mt-5 max-md:max-w-full mt-auto"
        >
          <button
            type="submit"
            [disabled]="
              !mobileOtpValue || mobileOtpValue.length !== 6 || loading
            "
            class="flex gap-1 justify-center items-center p-2 max-w-full rounded-lg bg-blue-950 w-full"
            [ngClass]="{
              'opacity-50 cursor-not-allowed':
                !mobileOtpValue || mobileOtpValue.length !== 6 || loading,
            }"
            (click)="verifyOtpSubmit()"
          >
            <span class="gap-2 self-stretch my-auto">
              <ng-container *ngIf="!loading">Verify OTP</ng-container>
              <ng-container *ngIf="loading">Verifying...</ng-container>
            </span>
          </button>
        </div>
      </section>
    </div>
  </div>
</main>
<main
  class="overflow-hidden max-w-full bg-white h-screen w-full sm:hidden flex flex-col"
  [attr.space]="0"
  *ngIf="createForm && !verificationStep"
>
  <!-- Mobile Header for Registration -->

  <header
    class="flex items-center justify-between px-4 py-3 bg-blue-200 min-h-[52px] flex-shrink-0"
  >
    <!-- Logo -->
    <img
      src="https://cdn.builder.io/api/v1/image/assets/TEMP/1b50e285eed6bc024f06731dea605f2b1649af32?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
      alt="Company Logo"
      class="w-[133px] object-contain"
    />

    <!-- Divider -->
    <div class="w-px h-6 bg-neutral-300"></div>

    <!-- Circularity -->
    <div
      class="flex items-center gap-1 text-xs font-semibold tracking-wide text-blue-950"
    >
      <div class="relative w-6 h-6">
        <svg
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="w-full h-full"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M3.5 9.5C4.87 4.39 10.14 1.35 15.26 2.73C18.69 3.65 21.19 6.31 22.05 9.52M3.5 9.5L1.8 6.57M3.5 9.5L6.86 8.55M22.05 14.48C20.67 19.61 15.41 22.64 10.29 21.27C6.86 20.35 4.36 17.69 3.5 14.48M22.05 14.48L23.74 17.42M22.05 14.48L18.68 15.45"
              stroke="#0A0A5F"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <text
            x="6"
            y="18"
            fill="#0A0A5F"
            font-size="18"
            font-family="Arial, sans-serif"
          >
            C
          </text>
          <defs>
            <clipPath id="clip0">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <span class="text-sm tracking-widest">IRCULARITY</span>
    </div>

    <!-- Divider -->
    <div class="w-px h-6 bg-neutral-300"></div>

    <!-- Menu Icon -->
    <img
      src="https://cdn.builder.io/api/v1/image/assets/TEMP/d74ff25c4e6b16aca0d967432703b6b2a47b1f47?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
      alt="Menu"
      class="w-8 object-contain"
    />
  </header>
  <div class="flex-1 overflow-auto">
    <app-register
      [businessOnly]="registerBusinessOnly"
      [checkoutMode]="verificationCheckoutMode"
      (businessStepComplete)="onBusinessStepComplete($event)"
      (closeModal)="onRegisterClose()"
    ></app-register>
  </div>
</main>
<main
  class="overflow-hidden max-w-full bg-white h-screen w-full sm:hidden flex flex-col"
  *ngIf="verificationStep"
>
  <header class="flex items-center justify-between px-4 py-3 bg-blue-200 min-h-[52px] flex-shrink-0">
    <img
      src="https://cdn.builder.io/api/v1/image/assets/TEMP/1b50e285eed6bc024f06731dea605f2b1649af32?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
      alt="Company Logo"
      class="w-[133px] object-contain"
    />
  </header>
  <div class="px-4 py-4 bg-sky-50 text-blue-950">
    <h2 class="text-lg font-bold">{{ verificationLeftPanelTitle }}</h2>
    <p class="mt-1 text-sm opacity-60">{{ verificationLeftPanelSubtext }}</p>
  </div>
  <div class="flex-1 overflow-auto px-4 py-4 pb-6">
    <ng-container *ngIf="verificationStep === 'gstin'">
      <h1 class="text-xl font-bold text-black mb-1">Select GSTIN</h1>
      <p class="text-sm opacity-60 mb-4">Choose an active GSTIN to continue.</p>
      <div class="flex flex-col gap-2 mb-4 max-h-[50vh] overflow-y-auto">
        <div *ngFor="let g of gstins" (click)="onGstinSelect(g)"
          class="relative p-3 rounded-lg border min-h-[56px]"
          [class.border-blue-500]="isGstinSelected(g)" [class.bg-blue-50]="isGstinSelected(g)"
          [class.border-neutral-300]="!isGstinSelected(g)" [class.opacity-50]="!isGstinActive(g)"
          [class.cursor-pointer]="isGstinActive(g)"
          [style.pointer-events]="isGstinActive(g) ? 'auto' : 'none'">
          <span class="font-bold text-sm block break-all pr-14">{{ g.document_number || g.gstin }}</span>
          <span class="text-xs text-neutral-500">{{ g.state }}</span>
          <span *ngIf="!isGstinActive(g)" class="absolute top-2 right-2 text-[10px] font-medium text-red-500 uppercase">
            {{ g.status || g.gstin_status }}
          </span>
        </div>
      </div>
      <button (click)="onGstinSubmit()" [disabled]="!selectedGstin || gstinLoading"
        class="p-2.5 w-full text-white rounded-lg bg-blue-950 font-bold"
        [class.opacity-60]="!selectedGstin || gstinLoading">
        <ng-container *ngIf="!gstinLoading">Continue</ng-container>
        <ng-container *ngIf="gstinLoading">Verifying...</ng-container>
      </button>
      <div *ngIf="gstinErrorMessage" class="text-red-500 text-sm mt-3 text-center">{{ gstinErrorMessage }}</div>
    </ng-container>
    <ng-container *ngIf="verificationStep === 'shop-license'">
      <h1 class="text-xl font-bold text-black mb-1">Shop License Details</h1>
      <p class="text-sm opacity-60 mb-4">
        No GSTINs were found. Enter your shop license details to continue.
      </p>
      <div class="flex flex-col gap-4 mb-4">
        <div class="flex flex-col gap-1">
          <label class="text-xs font-bold text-zinc-700">Verification Type</label>
          <select [(ngModel)]="shopLicenseType" (ngModelChange)="onShopLicenseTypeChange()"
            class="p-2 w-full h-10 rounded-lg border border-neutral-300 text-base bg-white">
            <option *ngFor="let option of shopLicenseTypeOptions" [ngValue]="option.value">{{ option.label }}</option>
          </select>
        </div>

        <ng-container *ngIf="shopLicenseType === 'uam'">
          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold text-zinc-700">UAM Number</label>
            <select *ngIf="udyamItems.length; else mobileUamManualInput"
              [(ngModel)]="uamNumber"
              (blur)="uamNumberTouched = true"
              class="p-2 w-full h-10 rounded-lg border text-base bg-white"
              [class.border-red-500]="getUamNumberError()"
              [class.border-neutral-300]="!getUamNumberError()">
              <option value="" disabled>Select UAM number</option>
              <option *ngFor="let u of udyamItems" [ngValue]="getUdyamNumber(u)">
                {{ getUdyamNumber(u) }}
              </option>
            </select>
            <ng-template #mobileUamManualInput>
              <input type="text" [(ngModel)]="uamNumber" (blur)="uamNumberTouched = true"
                placeholder="Enter UAM number"
                class="p-2 w-full h-10 rounded-lg border text-base"
                [class.border-red-500]="getUamNumberError()"
                [class.border-neutral-300]="!getUamNumberError()" />
            </ng-template>
            <div
              *ngIf="selectedUdyamItem?.state || selectedUdyamItem?.address"
              class="flex flex-col gap-1 p-3 mt-2 text-sm text-zinc-700 rounded-lg border border-neutral-300 bg-zinc-100"
            >
              <span *ngIf="selectedUdyamItem?.state">State: {{ selectedUdyamItem?.state }}</span>
              <span *ngIf="selectedUdyamItem?.address">
                Address: {{ selectedUdyamItem?.address }}<ng-container *ngIf="selectedUdyamItem?.pincode"> - {{ selectedUdyamItem?.pincode }}</ng-container>
              </span>
            </div>
            <div *ngIf="uamLookupLoading" class="text-xs mt-1 text-neutral-500">
              Fetching UAM numbers...
            </div>
            <div *ngIf="uamLookupErrorMessage" class="text-red-500 text-xs mt-1">
              {{ uamLookupErrorMessage }}
            </div>
            <div *ngIf="getUamNumberError()" class="text-red-500 text-xs mt-1">{{ getUamNumberError() }}</div>
          </div>
        </ng-container>

        <ng-container *ngIf="shopLicenseType === 'certificate'">
          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold text-zinc-700">Certificate Number</label>
            <input type="text" [(ngModel)]="shopLicenseNumber" (blur)="shopLicenseNumberTouched = true"
              placeholder="Enter shop license certificate number"
              class="p-2 w-full h-10 rounded-lg border text-base"
              [class.border-red-500]="getShopLicenseNumberError()"
              [class.border-neutral-300]="!getShopLicenseNumberError()" />
            <div *ngIf="getShopLicenseNumberError()" class="text-red-500 text-xs mt-1">{{ getShopLicenseNumberError() }}</div>
          </div>
          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold text-zinc-700">State</label>
            <select [(ngModel)]="shopLicenseState" (blur)="shopLicenseStateTouched = true"
              class="p-2 w-full h-10 rounded-lg border text-base bg-white"
              [class.border-red-500]="getShopLicenseStateError()"
              [class.border-neutral-300]="!getShopLicenseStateError()">
              <option value="" disabled>Select state</option>
              <option *ngFor="let state of shopLicenseStates" [value]="state">{{ formatShopLicenseStateLabel(state) }}</option>
            </select>
            <div *ngIf="getShopLicenseStateError()" class="text-red-500 text-xs mt-1">{{ getShopLicenseStateError() }}</div>
          </div>
          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold text-zinc-700">District</label>
            <input type="text" [(ngModel)]="shopLicenseDistrict" (blur)="shopLicenseDistrictTouched = true"
              placeholder="Enter district"
              class="p-2 w-full h-10 rounded-lg border text-base"
              [class.border-red-500]="getShopLicenseDistrictError()"
              [class.border-neutral-300]="!getShopLicenseDistrictError()" />
            <div *ngIf="getShopLicenseDistrictError()" class="text-red-500 text-xs mt-1">{{ getShopLicenseDistrictError() }}</div>
          </div>
          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold text-zinc-700">Commencement Date</label>
            <input type="date" [(ngModel)]="shopLicenseCommencementDate" (blur)="shopLicenseCommencementDateTouched = true"
              class="p-2 w-full h-10 rounded-lg border text-base"
              [class.border-red-500]="getShopLicenseCommencementDateError()"
              [class.border-neutral-300]="!getShopLicenseCommencementDateError()" />
            <div *ngIf="getShopLicenseCommencementDateError()" class="text-red-500 text-xs mt-1">{{ getShopLicenseCommencementDateError() }}</div>
          </div>
        </ng-container>
      </div>
      <button (click)="onShopLicenseSubmit()" [disabled]="!isShopLicenseValid() || shopLicenseLoading"
        class="p-2.5 w-full text-white rounded-lg bg-blue-950 font-bold"
        [class.opacity-60]="!isShopLicenseValid() || shopLicenseLoading">
        <ng-container *ngIf="!shopLicenseLoading">Continue</ng-container>
        <ng-container *ngIf="shopLicenseLoading">Verifying...</ng-container>
      </button>
      <div *ngIf="shopLicenseErrorMessage" class="text-red-500 text-sm mt-3 text-center">{{ shopLicenseErrorMessage }}</div>
    </ng-container>
    <ng-container *ngIf="verificationStep === 'status'">
      <div class="flex flex-col items-center text-center gap-4 pt-6">
        <h1 class="text-xl font-bold">{{ verificationLeftPanelTitle }}</h1>
        <p class="text-sm opacity-60 px-2">{{ verificationStatusDetail }}</p>
        <button *ngIf="verificationStatusState === 'verified'" (click)="onVerificationStatusContinue()"
          class="p-2.5 w-full text-white rounded-lg bg-blue-950 font-bold mt-4">Continue</button>
        <button *ngIf="verificationStatusState === 'failed'" (click)="onVerificationStatusRetry()"
          class="p-2.5 w-full text-white rounded-lg bg-blue-950 font-bold mt-4">Retry</button>
      </div>
    </ng-container>
    <ng-container *ngIf="verificationStep === 'activated'">
      <div class="flex flex-col items-center text-center gap-4 pt-6">
        <h1 class="text-xl font-bold">Account activated</h1>
        <p class="text-sm opacity-60">Ready to browse and order</p>
        <button (click)="onAccountActivated()" class="p-2.5 w-full text-white rounded-lg bg-blue-950 font-bold mt-4">
          Start browsing
        </button>
      </div>
    </ng-container>
  </div>
</main>
